import axios from '../util/Axios';
import { useAsync } from './use-async';

const blobCache = new Map();

export function useResourceBlob(url) {
  return useAsync(async () => {
    if (blobCache.has(url)) {
      return blobCache.get(url);
    }
    const { data } = await axios(url, { responseType: 'blob' });
    const blob = window.URL.createObjectURL(new Blob([data]));

    blobCache.set(url, blob);

    return blob;
  }, [url]);
}
